import React, { useState } from 'react';
import { observer } from 'src/utils/mobx-react';
import { Input } from 'src/domains/common/components/input/input';
import { BonusCard } from 'src/components/CustomersBar/CustomerTab/PromotionHistory/BonusCard';
import { Switch } from 'src/domains/common/components/switch/switch';
import { PromotionDetails } from 'src/components/CustomersBar/CustomerTab/PromotionHistory/PromotionDetails/PromotionDetails';
import { BonusModel } from 'src/domains/casino/state/AppCasino/store/campaign-store/BonusModel';
import { LoadingV2 } from 'src/components/Loading/LoadingV2';
import { RewardsNavigationState } from 'src/components/CustomersBar/CustomerTab/PromotionHistory/PromotionHistoryTabs/RewardTab/RewardsNavigation.state';
import { FilterMenu } from 'src/domains/casino/webview/bonus-engine/campaign-list/filters/Filters';
import { RewardType } from 'src/components/CustomersBar/CustomerTab/PromotionHistory/BonusCardState';
import { cn } from 'src/domains/common/components/utils';

export interface RewardTabPropsType {
    type: RewardType;
    userId: number;
    bonusModels: () => Array<BonusModel> | 'loading';
}

export const RewardTab = observer('RewardTab', (props: RewardTabPropsType) => {
    const [promotionNavigationState] = useState(() => new RewardsNavigationState(props.bonusModels));
    const isDetailsView = promotionNavigationState.activeModel !== null;

    if (promotionNavigationState.bonusesForVew === 'loading') {
        return (
            <LoadingV2
                dataTest=''
                title='Loading bonuses...'
            />
        );
    }

    return (
        <>
            <div className='flex flex-row items-center justify-between'>
                <Switch
                    labelPosition='right'
                    checked={promotionNavigationState.hideExpired}
                    onChange={promotionNavigationState.onToggleExpired}
                    label='Hide Expired'
                />
                <div className='flex items-center'>
                    <Input
                        placeholder='Search'
                        formInputState={promotionNavigationState.searchInput}
                        errors={[]}
                        className='w-[251px] mr-4'
                    />
                    <FilterMenu
                        campaignListState={promotionNavigationState}
                        submenuPosition='left'
                    />
                </div>
            </div>

            <div className='grid grid-cols-12 gap-3 h-fit'>
                <div
                    className={cn('grid grid-cols-3 col-span-12 gap-3', {
                        'col-span-3 grid-cols-1 h-fit': isDetailsView,
                    })}
                >
                    {promotionNavigationState.bonusesForVew.map((bonusModel) => (
                        <BonusCard
                            type={props.type}
                            userId={props.userId}
                            key={bonusModel.id}
                            bonusModel={bonusModel}
                            state={promotionNavigationState}
                        />
                    ))}
                </div>
                {isDetailsView && (
                    <div className='col-span-9'>
                        <PromotionDetails
                            bonusModel={promotionNavigationState.activeModel}
                            userId={props.userId}
                        />
                    </div>
                )}
            </div>
        </>
    );
});
